var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",attrs:{"tabindex":1},on:{"click":function($event){return _vm.handleEnterBtnClick(_vm.buyStatus)}}},[_c('div',{staticClass:"card-head"},[_c('img',{staticClass:"icon",attrs:{"src":_vm.faceImg,"width":"100%"}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }